export const SOCKET_EVENTS = {
  CHAT_MESSAGE: 'intervene.chat.message',
  SESSION_UPDATED: 'intervene.session.updated',
  PRESENCE_UPDATED: 'intervene.presence.updated',
  LIST_UPDATED: 'intervene.list.updated',
  COUNTS_UPDATED: 'intervene.counts.updated',
  MESSAGE_STATUS: 'intervene.message.status',
};

export const LEGACY_EVENTS = {
  CHAT_MESSAGES: 'chatMessages',
  INTERVENE_STATUS: 'intervene_status',
  CURRENT_USERS: 'current_users_on_chat',
  STATUS_NOTIFICATION: 'status_notification',
  NOTIFICATION: 'notification',
};

export const NOTIFICATION_TYPES = {
  UNREAD_COUNTS: 'unread_message_counts',
  QUEUE_COUNTS: 'queue_counts_updated',
  NEW_USER_MESSAGE: 'new_user_message_initiated',
  CONVERSATION_UNREAD: 'conversation_unread',
};

export const CLIENT_EVENTS = {
  ACTIVE_USER: 'active_user',
  INACTIVE_USER: 'inactive_user',
  MARK_READ: 'mark_read',
  WATCH_BOT: 'watch_bot',
};
